import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { resetSignupState } from "./signup";
import { loginSuccess } from "./auth";
import { CreatePlayload } from "../../lib/token";
import { fbq } from "../../fbq";
import { addBonusModal } from "./gift";
import { registerAndSaveFcmToken } from "../../lib/fcm";

const initialState = {
  token: null,
  otp: null,
  loading: false,
  error: null,
  resending: false,
};

// Create the slice
const authSliceVeify = createSlice({
  name: "verify",
  initialState,
  reducers: {
    startfun(state) {
      state.loading = true;
      state.error = null;
    },
    setResending(state, action) {
      state.resending = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
      state.loading = false;
      state.error = null;
    },
    setOtp(state, action) {
      state.otp = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearAuth(state) {
      state.token = null;
      state.otp = null;
      state.loading = false;
      state.error = null;
    },
    verifyFailure: (state, action) => {
      state.loading = false;
      state.otp = false;
      state.error = action.payload;
    },
  },
});

export const {
  startfun,
  
  
  clearAuth,
  verifyFailure,
  setResending,
} = authSliceVeify.actions;

export const verifyOtp = (data, navigate) => async (dispatch) => {
  try {
    dispatch(startfun());
    const response = await axios.post("/public/verify", data);
    localStorage.removeItem("acs");
    if (response?.status === 201) {
      const { user, token } = response.data;
      // Fire CompleteRegistration now (OTP verified = real signup complete)
      fbq("track", "CompleteRegistration", {
        status: "success",
        content_name: "Signup",
        value: 0,
        currency: "USD",
        email: user?.email ?? data?.email ?? undefined,
      });
      dispatch(resetSignupState(user));
      dispatch(clearAuth(user));
      dispatch(loginSuccess({ user, token }));
      const Token = CreatePlayload(CreatePlayload(user));
      localStorage.setItem("logged", Token?.token);
      localStorage.removeItem("acs");

      // Save FCM token so admin can push notifications
      registerAndSaveFcmToken(user?.email);

      navigate("/dashboard");
      toast.success("Thank you for verification!");
      dispatch(addBonusModal("signup"));
      dispatch(addBonusModal("deposit"));
    } else {
      throw Error("Verification failed");
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || String(err));
    dispatch(verifyFailure(err?.response?.data?.message || err));
  }
};

export const OtpResend = (data, navigate) => async (dispatch) => {
  try {
    dispatch(setResending(true));
    const response = await axios.put("/public/verify", data);

    if (response?.status === 200) {
      toast.success("Please Check your Inbox!");
    }
    dispatch(setResending(false));
  } catch (err) {
    toast.error(err?.response?.data?.message || err);
    dispatch(setResending(false));
  }
};

export default authSliceVeify.reducer;
